<template>
  <footer class="footer">
    <div class="container footer-content">
      <div class="footer-section footer-brand">
        <h3>Мама, я в Китае</h3>
        <p>ИП Мищенко Алина Сергеевна</p>
        <p>ИНН 545328832110</p>
        <p>ОГРНИП 323547600086166</p>
      </div>
      <div class="footer-section footer-links">
        <h3>Навигация</h3>
        <ul>
          <li><router-link to="/">Главная</router-link></li>
          <li><router-link to="/hsk">Всё об HSK</router-link></li>
          <li><router-link to="/prices">Цены</router-link></li>
          <li><router-link to="/teachers">Преподаватели</router-link></li>
          <li><router-link to="/contacts">Контакты</router-link></li>
        </ul>
      </div>
      <div class="footer-section footer-links">
        <h3>Контакты</h3>
        <ul>
          <li v-if="contacts.show_email_on_site && contacts.email_contact">
            <a :href="`mailto:${contacts.email_contact}`">{{ contacts.email_contact }}</a>
          </li>
          <li v-if="contacts.show_telegram_on_site && contacts.telegram_link">
            <a :href="contacts.telegram_link" target="_blank" rel="noopener">Telegram</a>
          </li>
          <li v-if="contacts.show_max_on_site && contacts.max_link">
            <a :href="contacts.max_link" target="_blank" rel="noopener">MAX</a>
          </li>
          <li v-if="contacts.show_instagram_on_site && contacts.instagram_link">
            <a :href="contacts.instagram_link" target="_blank" rel="noopener">Instagram</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom container">
      <p>&copy; {{ currentYear }} Мама, я в Китае</p>
      <div class="footer-legal">
        <router-link to="/terms">Пользовательское соглашение</router-link>
        <span class="footer-sep">·</span>
        <router-link to="/privacy">Политика конфиденциальности</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'UIFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      contacts: {
        show_email_on_site: false,
        email_contact: null,
        show_telegram_on_site: false,
        telegram_link: null,
        show_max_on_site: false,
        max_link: null,
        show_instagram_on_site: false,
        instagram_link: null,
      }
    }
  },
  async mounted() {
    await this.loadContacts()
  },
  methods: {
    async loadContacts() {
      try {
        const resp = await fetch('/api/v1/public/site-settings')
        if (resp.ok) {
          const data = await resp.json()
          this.contacts = {
            show_email_on_site: !!data.show_email_on_site,
            email_contact: data.email_contact || null,
            show_telegram_on_site: !!data.show_telegram_on_site,
            telegram_link: data.telegram_link || null,
            show_max_on_site: !!data.show_max_on_site,
            max_link: data.max_link || null,
            show_instagram_on_site: !!data.show_instagram_on_site,
            instagram_link: data.instagram_link || null,
          }
        }
      } catch (e) {
        console.error('Failed to load contacts', e)
      }
    }
  }
}
</script>

<style scoped>
.footer {
  background: #111827;
  color: rgba(255,255,255,0.78);
  padding: 42px 0 24px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 32px;
  align-items: start;
  margin-bottom: 0;
}

.footer-section {
  min-width: 0;
}

.footer-section h3 {
  color: #f8fafc;
  font-weight: 700;
  margin-bottom: 10px;
  font-size: 1rem;
}

.footer-section p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 25px;
}

.footer-brand p + p {
  margin-top: 6px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 6px;
}

.footer-links li {
  min-width: 0;
  line-height: 25px;
}

.footer-links a {
  display: inline-flex;
  align-items: center;
  min-height: 25px;
  max-width: 100%;
  overflow-wrap: anywhere;
}

.footer-section a {
  color: rgba(255,255,255,0.7);
  font-size: 0.92rem;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-section a:hover {
  color: #ffffff;
}

.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.08);
  margin-top: 22px;
  padding-top: 18px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
  color: rgba(255,255,255,0.6);
  font-size: 0.9rem;
}

.footer-bottom a {
  color: rgba(255,255,255,0.8);
  text-decoration: none;
}

.footer-bottom a:hover {
  color: #ffffff;
}

.footer-legal {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.footer-sep {
  color: rgba(255,255,255,0.4);
}

@media (max-width: 700px) {
  .footer { padding: 34px 0 20px; }
  .footer-content { grid-template-columns: 1fr; gap: 22px; }
  .footer-bottom { margin-top: 20px; padding-top: 16px; gap: 10px; }
}

@media (max-width: 520px) {
  .footer-bottom { display: grid; }
  .footer-legal { gap: 5px 8px; }
}
</style>
